export const CLICLSREAM_VALUES = {
    eventTypes: {
        clearingVisitWebsite: "ClearingVisitWebsite",
        visitWebsite: "VisitWebsite",
        prospectusRequestClicked: "ProspectusRequestClicked",
        enquiryFormClicked: "EnquiryFormClicked"
    }
}